// extracted by mini-css-extract-plugin
module.exports = {"group":"Group_group__2TkkM","closed":"Group_closed__dHkdE","header":"Group_header__1vf7z"};